import { cn } from '~/lib/utils';
import styles from './PowerPointVisual.module.css';

export interface PowerPointVisualProps {
  className?: string;
}

export const PowerPointVisual = ({ className }: PowerPointVisualProps) => {
  return (
    <div className={cn(styles.window, className)}>
      <div className={styles.toolbar}>
        <div className={styles.toolbarPill} style={{ width: 65 }} />
        <div className={styles.toolbarPill} style={{ width: 41 }} />
        <div className={styles.toolbarPill} style={{ width: 41 }} />
        <div className={styles.toolbarPill} style={{ width: 41 }} />
        <div className={styles.toolbarPill} style={{ width: 41 }} />
        <div className={styles.toolbarPill} style={{ width: 41 }} />
        <div className={styles.windowControls}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6h8" stroke="rgba(39,39,42,0.25)" strokeWidth="1.2" strokeLinecap="round"/></svg>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><rect x="2" y="2" width="8" height="8" rx="1" stroke="rgba(39,39,42,0.25)" strokeWidth="1.2"/></svg>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M3 3l6 6M9 3l-6 6" stroke="rgba(39,39,42,0.25)" strokeWidth="1.2" strokeLinecap="round"/></svg>
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.sidebar}>
          <div className={styles.thumbnail} />
          <div className={styles.thumbnail} />
          <div className={styles.thumbnail} />
          <div className={styles.sidebarAction} />
        </div>
        <div className={styles.canvasArea}>
          <div className={styles.canvas}>
            <div className={styles.titleContainer}>
              <span className={styles.titlePlaceholder}>Click to add title</span>
            </div>
            <div className={styles.subtitleContainer}>
              <span className={styles.subtitlePlaceholder}>Click to add subtitle</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PowerPointVisual.displayName = 'PowerPointVisual';
